import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { Dialog } from '@mui/material';
var AwaitedDialog = function (_ref) {
    var children = _ref.children, others = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ React.createElement(Dialog, others, children);
};
export default AwaitedDialog;
